var _rect, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreAssessment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#D7D5FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 35,
    fill: "#617AF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5742 20.6099L42.8096 47.478H36.9297L36.165 20.6099H43.5742ZM35.9541 55.7573C35.9541 54.7202 36.3057 53.8501 37.0088 53.147C37.7295 52.4263 38.6963 52.0659 39.9092 52.0659C41.1221 52.0659 42.0801 52.4263 42.7832 53.147C43.5039 53.8501 43.8643 54.7202 43.8643 55.7573C43.8643 56.7769 43.5039 57.6382 42.7832 58.3413C42.0801 59.0444 41.1221 59.396 39.9092 59.396C38.6963 59.396 37.7295 59.0444 37.0088 58.3413C36.3057 57.6382 35.9541 56.7769 35.9541 55.7573Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreAssessment);
export default __webpack_public_path__ + "static/media/pre-assessment.f08e9950196bf04b62187de278605306.svg";
export { ForwardRef as ReactComponent };